<template>
  <div class="small-shop" v-cloak style="background-color: #f7f7f7;" ref="container">
    <div class="small-shop-info width92">
      <div class="small-shop-info-title">
        {{ smallStoreInfo.small_store_name }}<p>的小店</p>
      </div>
      <div class="small-shop-share" @click="setShareInfoStatus">
        <div class="small-shop-share-img">
          <img src="../../assets/images/smallstore_share.jpg" alt="">
        </div>
        <div class="small-shop-share-title">分享</div>
      </div>
    </div>
    <div class="smallshop-top">
      <div class="search-wrap">
        <van-search v-model="inputValue" background="#f7f7f7" shape="round" input-align="center"
          placeholder="搜索你想要的优质商品" @search="onSearch" :clearable="true" />
      </div>
      <div class="smallshop-banner width92">
        <img :src="banner" alt="" @click="urlgo()">
      </div>
    </div>
    <div class="small-shop">
      <div class="width92 small-shop-container">
        <div class="smallshop-page-title">
          <div class="smallshop-page-title-left">
            <div class="page-title">精选特惠</div>
            <div class="page-size">百款好物 任你挑选</div>
          </div>
        </div>
        <div class="small-shop-bom">
          <div class="small-shop-card" v-for="(item, index) in smallShopList">
            <router-link :to="{ path: '/detail/' + item.id + '?small_store_uid=' + smallStoreInfo.small_store_uid }">
              <div class="small-shop-card-img">
                <img :src="item.image" alt="">
              </div>
              <div class="small-shop-card-info">
                <div class="title">{{ item.store_name }}</div>
                <div class="num">￥{{ item.price }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Loading :loadend="loadend" :loading="loading"></Loading>
    <ShareInfo v-on:setShareInfoStatus="setShareInfoStatus" :shareInfoStatus="shareInfoStatus"></ShareInfo>
  </div>
</template>

<script>
import "@assets/css/swiper.min.css";
import Loading from "@components/Loading";
import Search from 'vant/lib/search'
import 'vant/lib/search/style'
import Swipe from 'vant/lib/swipe'
import 'vant/lib/swipe/style'
import SwipeItem from 'vant/lib/swipe-item'
import 'vant/lib/swipe-item/style'
import { getUserInfo } from "@api/user";
import { getSmalStore, getSmalStoreInfo } from '@api/store.js'
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
import ShareInfo from "@components/ShareInfo";
export default {
  name: "smallshop",
  props: {},
  data: function () {
    return {
      smallShopList: [],
      url: '',
      banner: [],
      data: {
        page: 1,
        limit: 4,
        keyword: ''
      },
      smallStoreUid: 0,
      loading: false,
      loadend: false,
      smallStoreInfo: {},
      inputValue: '',
      shareInfoStatus: false,
    };
  },
  components: {
    [Search.name]: Search,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    Loading,
    ShareInfo
  },
  created() {
    this.getSmalStoreList()

  },
  activated() { //组件被缓存时 每次进入触发
    getSmalStoreInfo({
      small_store_uid: this.$route.query.small_store_uid ? this.$route.query.small_store_uid : this.smallStoreUid
    }).then(res => {
      this.smallStoreInfo = res.data
      this.smallStoreInfo.small_store_name = res.data.small_store_name.split('(所有者)')[0]
    }).catch(err => {
      this.$dialog.error(err.msg);
      return this.$router.push({ path: '/user' })
    })
  },
  mounted: function () {
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getSmalStoreList();
    });


    
  },
  methods: {
    getSmalStoreList() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      getSmalStore(this.data).then(res => {
        this.banner = res.data.banner[0].pic
        this.url = res.data.banner[0].wap_url
        that.loading = false;
        that.imgUrls = res.data.banner;
        //apply();js将一个数组插入另一个数组;
        that.smallShopList.push.apply(that.smallShopList, res.data.list);
        that.loadend = res.data.list.length < that.data.limit; //判断所有数据是否加载完成；
        that.data.page = that.data.page + 1;
        that.setOpenShare();
      }).catch(err => {
        that.$dialog.error(err.msg);
      });
    },
    setOpenShare() {
      var href = location.href;
      if (isWeixin()) {
        href =
          href.indexOf("?") === -1
            ? href + "?small_store_uid=" + this.smallStoreInfo.small_store_uid
            : href + "&small_store_uid=" + this.smallStoreInfo.small_store_uid;
        var configAppMessage = {
          desc: this.smallStoreInfo.small_store_name + '邀请您去小店购买，快来看看吧',
          title: this.smallStoreInfo.small_store_name + '的小店',
          link: href,
          imgUrl: this.banner
        };
        wechatEvevt(
          [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareAppMessage",
            "onMenuShareTimeline"
          ],
          configAppMessage
        )
          .then(res => {
            console.log('res--------------------->', res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.updateAppMessageShareData(configAppMessage);
              res.wx.onMenuShareAppMessage(configAppMessage);
              res.wx.updateTimelineShareData(configAppMessage);
              res.wx.onMenuShareTimeline(configAppMessage);
            }
          });
      }
    },
    // 搜索函数
    onSearch(inputValue) {
      console.log('inputValue', inputValue);
      this.smallShopList = []
      this.data.keyword = inputValue
      this.data.page = 1
      this.loadend = false;
      this.loading = false;
      this.getSmalStoreList()
    },
    urlgo() {
      this.$router.push({ path: this.url });
    },
    setShareInfoStatus() {
      console.log('111111111', this.shareInfoStatus);
      this.shareInfoStatus = !this.shareInfoStatus;
    }
  }
};
</script>
<style scoped>
/* 追风者 -- 发型师小店 */

.small-shop-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: .2rem auto 0.1rem auto !important;
}

.small-shop-share {
  display: flex;
  align-items: center;
  background-color: #d8caaf;
  padding: 0.04rem 0.2rem;
  border-radius: .3rem;
}

.small-shop-share-img {
  width: 0.45rem;
  height: 0.45rem;
}

.small-shop-share-title {
  color: #000;
  font-size: .26rem;
  padding: 0 .1rem;
}

.small-shop-share-img>img {
  width: 100%;
  height: 100%;
}

.small-shop-info-title {
  display: flex;
  align-items: flex-end;
  font-size: 0.38rem;
  color: #000;
}

.small-shop-info-title>p {
  font-size: .26rem;
  padding-left: .1rem;
  color: #ccc;
}

.van-search__content {
  background-color: #fff;
  padding-left: .4rem
}

.search-wrap .van-search {
  padding: 0.2rem 0.3rem;
}

.search-wrap ::v-deep .van-icon-search {
  font-size: 20px !important;
  color: #ccc;
}

.width92 {
  width: 92%;
  margin: 0 auto;
}

.smallshop-banner>img {
  width: 100%;
}

/* 公用标题部分 */
.smallshop-page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.22rem 0;
}

.smallshop-page-title-left {
  display: flex;
}

.smallshop-page-title .page-title {
  font-size: .38rem;
  color: #000;
}

.smallshop-page-title .page-size {
  font-size: .26rem;
  padding-left: .18rem;
  color: #666;
  line-height: 0.55rem;
}

.smallshop-page-title>p {
  font-size: .26rem;
  color: #666;
}

.small-shop-bom {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.small-shop-card {
  margin-bottom: .35rem;
  flex: 0 0 48%;
  box-shadow: 0.01rem 0.01rem 0.12rem #e6e6e6;
  border-radius: .1rem;
  overflow: hidden;
}

.small-shop-card-img {
  width: 3.35rem;
  height: 2.86rem;
  border-radius: .1rem;
  overflow: hidden;
  object-fit: cover;
}

.small-shop-card-img>img {
  width: 100%;
  height: 100%;
  border-radius: .1rem;
  object-fit: cover;
  overflow: hidden;
}

.small-shop-card .small-shop-card-info {
  padding: .3rem .2rem;
}

.small-shop-card .title {
  font-size: .28rem;
  color: #000;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.small-shop-card-info .num {
  font-size: .3rem;
  font-weight: bold;
  padding-top: .26rem;
  color: #c6af8b;
}

.small-shop .more {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: .28rem;
  color: #666;
}

/* -------------------------------------------------------------------------------------------------------------------------- */

.bottom-safe {
  height: 1.2rem;
}
</style>